import styled from 'styled-components';

import { colors } from 'ui/theme';

export const SpecialSection = styled.section`
  background-color: ${colors.backgroundTertiary};
  border-radius: 4px;
  border: ${({ theme }) => `${theme.spacing.values.single} solid ${colors.borderPrimary}`};
  display: flex;
  flex-direction: column;
`;
